// extracted by mini-css-extract-plugin
export default {"box":"specification-form_box__lHi2w","note":"specification-form_note__KQSDS"};